// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ServicedAreasPage from "../pages/ServicedAreas/ServicedAreas";
const __wvcRoutePaths = ["/ServicedAreasPage", "/zones-desservies"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["accueil", "camerainspectionpage", "contact", "contactpage", "debouchage", "debouchage-de-drains-a-montreal", "draincleaninginmontrealpage", "frequentlyaskedquestionspage", "homepage", "inspection-camera", "post", "questions-frequentes", "servicedareaspage", "uncloggingpage", "zones-desservies"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<ServicedAreasPage />} />
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ServicedAreasPage />} />
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
